import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Processo } from 'src/app/model/Processo';
import { AuthService } from 'src/app/seguranca/auth.service';
import { AreaAtuacaoProcessoFilter, AssuntoCnjFilter, FaseProcessoFilter, JuridicoService, MovimentoProcessoFilter, OrgaoJulgadorFilter, TribunalFilter } from '../juridico.service';
import { ErroNotificacaoService } from 'src/app/erro-notificacao.service';
import { ToastrService } from 'ngx-toastr';
import { SocioDependente } from 'src/app/model/SocioDependente';
import { ProcessoAdvogado } from 'src/app/model/ProcessoAdvogado';
import { AreaAtuacaoProcesso } from 'src/app/model/AreaAtuacaoProcesso';
import { ClasseProcessual } from 'src/app/model/ClasseProcessual';
import { AssuntoCnj } from 'src/app/model/AssuntoCnj';
import { FaseProcesso } from 'src/app/model/FaseProcesso';
import { Tribunal } from 'src/app/model/Tribunal';
import { OrgaoJulgador } from 'src/app/model/OrgaoJulgador';
import { MovimentacaoProcesso } from 'src/app/model/MovimentacaoProcesso';
import { ProcessoConsultadoAssociado } from 'src/app/model/ProcessoConsultadoAssociado';
import moment from 'moment';
import { Pessoa } from 'src/app/model/Pessoa';
import { GrupoProcesso } from 'src/app/model/GrupoProcesso';
import { Instancia } from 'src/app/model/Instancia';

@Component({
  selector: 'app-movimentacao-processo',
  templateUrl: './movimentacao-processo.component.html',
  styleUrls: ['./movimentacao-processo.component.css']
})
export class MovimentacaoProcessoComponent implements OnInit {

  token: any;
  payLoad: any;

  strDependenteSocio = '';
  idSocioDependente = 0;
  idSocio = 0;
  tipoSocio = '';
  foto = '';
  socioDependente = new SocioDependente();
  strTelefone = '';
  editandoProcesso = '';

  processo = new Processo();

  gruposProcessos = [];
  areasAtuacoes = [];
  classesProcessuais = [];
  assuntosCnj = [];
  tiposMovimentacoesCnj = [];
  fasesProcessos = [];
  tribunais = [];
  orgaoJulgadores = [];
  instancias = [];

  advogadosListar: Pessoa[] = [];
  advogados = [];
  idAdvogado = 0;
  pessoa: any;

  advogadosSelecionadosProcesso: Array<ProcessoAdvogado> = [];
  processoAdvogado = new ProcessoAdvogado();
  advogadosEnvolvidosTotal = 0;

  idProcesso = 0;
  dataProcesso = new Date();

  areaAtuacaoProcessoFilter = new AreaAtuacaoProcessoFilter();
  classeProcessualFilter = new AreaAtuacaoProcessoFilter();
  assuntoCnjFilter = new AssuntoCnjFilter();
  faseProcessoFilter = new FaseProcessoFilter();
  tribunalFilter = new TribunalFilter();
  orgaoJulgadorFilter = new OrgaoJulgadorFilter();

  areaAtuacaoProcesso = new AreaAtuacaoProcesso();
  classeProcessual = new ClasseProcessual();
  assuntoCnj = new AssuntoCnj();
  faseProcesso = new FaseProcesso();
  tribunal = new Tribunal();
  orgaoJulgador = new OrgaoJulgador();

  areasAtuacoesPage = [];
  totalAreaAtuacao = 0;
  classesProcessuaisPage = [];
  totalClasseProcessual = 0;
  assuntosCnjPage = [];
  totalAssuntosCnj = 0;
  fasesProcessosPage = [];
  totalFaseProcesso = 0;
  tribunaisPage = [];
  totalTribunalPage = 0;
  orgoesJulgadoresPage = [];
  totalOrgoesJulgadores = 0;

  movimentacoesProcesso = [];
  totalRegistrosMovimentacoesProcesso = 0;
  movimentoProcessoFilter = new MovimentoProcessoFilter();
  movimentoProcesso = new MovimentacaoProcesso();
  intConsultarProcesso = 0;
  processoConsultadoAssociado = new ProcessoConsultadoAssociado();

  dataArquivar = new Date();
  opcaoArquivarProcesso = 0;

  aguardeDialog = false;
  renovarLoginDialog = false;
  areaAtuacaoDialog = false;
  subareaAtuacaoDialog = false;
  assuntoCnjDialog = false;
  faseProcessoDialog = false;
  tribunalDialog = false;
  orgaoJulgadorDialog = false;
  movimentacaoProcessoDialog = false;
  processoExistenteDialog = false;
  arquivarDialog = false;

  movimentos = [];

  constructor(
    private jwtDecoder: JwtHelperService,
    private auth: AuthService,
    private juridicoService: JuridicoService,
    private erro: ErroNotificacaoService,
    private rota: ActivatedRoute,
    private toasty: ToastrService,
    private rotaNavegar: Router
  ) { }

  ngOnInit(): void {

    this.token = localStorage.getItem('access_token_xmanager');
    window.scrollTo(0, 0);
    this.payLoad = this.jwtDecoder.decodeToken(this.token);
    this.idProcesso = this.rota.snapshot.params.id;
    this.tipoSocio = this.payLoad.tipoSocio;
    this.movimentoProcessoFilter.id = this.idProcesso;
    this.idSocioDependente = this.payLoad.id;
    this.popularCampos();
  }

  popularCampos() {
    if (!this.auth.isAccessTokenInvalido()) {
      this.pesquisarSocioDependenteID(this.idSocioDependente, this.tipoSocio);
      this.grupoProcessoListar();
      this.pesquisarAreaAtuacaoProcesso();
      this.fasesProcessoListar();
      this.tribunaisListar();
      this.orgaosJulgadoresListar();
      this.instanciasListar();
      this.pesquisarProcesso();
    } else {
      this.renovarLoginDialog = true
    }
  }

  pesquisarProcesso() {
    if (!this.auth.isAccessTokenInvalido()) {
      this.juridicoService.buscarProcessoPorIdComMovimentacao(this.idProcesso, this.token).subscribe(
        (dados: any) => {
          this.processo = dados;
          this.pessoa = dados.pessoa;
          if (this.pessoa == null) {
            this.pessoa = new Pessoa();
          }

          this.dataProcesso = moment(this.processo.dataHora, 'YYYY-MM-DD').toDate();
          if (this.processo.dataDistribuicao != null) {
            this.processo.dataDistribuicao = moment(this.processo.dataDistribuicao, 'YYYY-MM-DD').toDate();
          }

          if (this.processo.grupoProcesso == null) {
            this.processo.grupoProcesso = new GrupoProcesso();
          }

          if (this.processo.areaAtuacaoProcesso == null) {
            this.processo.areaAtuacaoProcesso = new AreaAtuacaoProcesso();
          }

          if (this.processo.assuntoCnj == null) {
            this.processo.assuntoCnj = new AssuntoCnj();
          }

          if (this.processo.faseProcesso == null) {
            this.processo.faseProcesso = new FaseProcesso();
          }

          if (this.processo.instancia == null) {
            this.processo.instancia = new Instancia();
          }

          if (this.processo.orgaoJulgador == null) {
            this.processo.orgaoJulgador = new OrgaoJulgador();
          }

          if (this.processo.tribunal == null) {
            this.processo.tribunal = new Tribunal();
          }

          if (this.processo.classeProcessual == null) {
            this.processo.classeProcessual = new ClasseProcessual();
          }

          if (dados.dataPeticaoHabilitadao != null) {
            this.processo.dataPeticaoHabilitadao = moment(this.processo.dataPeticaoHabilitadao, 'YYYY-MM-DD').toDate();
          }

          if (this.processo.advogados.length == 0) {
            if (dados.pessoa != null) {
              let flagAdvogadoDesligado = 0;
              for (let i = 0; i < this.advogadosListar.length; i++) {
                if (dados.pessoa.id == this.advogadosListar[i].id) {
                  this.processoAdvogado.id = 0;
                  this.processoAdvogado.idAdvogado = dados.pessoa.id;
                  this.processoAdvogado.nome = dados.pessoa.nome;
                  this.processoAdvogado.oab = dados.pessoa.oab;
                  this.processoAdvogado.idProcesso = this.idProcesso;
                  this.aguardeDialog = true;
                  flagAdvogadoDesligado = 1;
                  /*
                  this.juridicoService.criarProcessoAdvogado(this.processoAdvogado, this.payLoad.id, this.token).subscribe(
                    (dados: any) => {
                      this.toasty.success('INCLUÍDO COM SUCESSO!', 'ATENÇÃO!');
                      this.advogadosSelecionadosProcesso.push(dados);
                      this.processoAdvogado = new ProcessoAdvogado();
                      this.aguardeDialog = false;
                    }, erro => {
                      this.erroHandle.handle(erro);
                      this.aguardeDialog = false;
                    }
                  );
                  */
                  break;
                }
              }
              /*
              if (flagAdvogadoDesligado == 0) {
                this.processoAdvogado.id = 0;
                this.processoAdvogado.idAdvogado = dados.pessoa.id;
                this.processoAdvogado.nome = dados.pessoa.nome;
                this.processoAdvogado.oab = dados.pessoa.oab;
                this.processoAdvogado.idProcesso = this.idProcesso;
                this.juridicoService.criarProcessoAdvogado(this.processoAdvogado, this.payLoad.id, this.token).subscribe(
                  (dados: any) => {
                    this.toasty.success('INCLUÍDO COM SUCESSO!', 'ATENÇÃO!');
                    this.advogadosSelecionadosProcesso.push(dados);
                    this.processoAdvogado = new ProcessoAdvogado();
                    flagAdvogadoDesligado = 1;
                    this.aguardeDialog = false;
                  }, erro => {
                    this.erroHandle.handle(erro);
                    this.aguardeDialog = false;
                  }
                );
              }
              */
            } else {
              this.idAdvogado = 0;
            }
          } else {
            this.advogadosSelecionadosProcesso = this.processo.advogados;
          }

          if (this.processo.assuntoCnj != null) {
            if (this.processo.assuntoCnj.id != 0) {
              this.juridicoService.buscarAssuntoPorId(this.processo.assuntoCnj.id, this.token).subscribe(
                (dados: any) => {
                  this.assuntosCnj = dados.map((a: { nome: any; id: any; }) => ({ label: a.nome, value: a.id }));
                }, (erro: any) => {
                  this.erro.handle(erro);
                }
              );
            }
          }

          if (this.processo.classeProcessual != null) {
            if (this.processo.classeProcessual.id != 0) {
              this.juridicoService.buscarClasseProcessualPorId(this.processo.classeProcessual.id, this.token).subscribe(
                (dados: any) => {
                  this.classesProcessuais = dados.map((c: { nome: any; id: any; }) => ({ label: c.nome, value: c.id }));
                }, (erro: any) => {
                  this.erro.handle(erro);
                }
              );
            }
          }

          if (!this.processo.isAutor) {
            this.processo.isAutor = false;
          }
          this.aguardeDialog = false;
        }, erro => {
          this.erro.handle(erro);
          this.aguardeDialog = false;
        });
    } else {
      this.renovarLoginDialog = true;
    }
  }

  pesquisarSocioDependenteID(idSocioDependente: number, tipoSocio: string) {
    if (!this.auth.isAccessTokenInvalido()) {
      this.aguardeDialog = true;
      this.juridicoService.pesquisarSocioDependenteProcesso(idSocioDependente, tipoSocio, this.token).subscribe(
        (dados: any) => {
          this.tipoSocio = tipoSocio;
          dados.dataCadastro = moment(dados.dataCadastro, 'YYYY-MM-DD').toDate();
          this.socioDependente = dados;
          this.foto = `data:image/png;base64,` + this.socioDependente.foto;

          if (this.socioDependente.tipo == 'S') {
            this.idSocio = this.idSocioDependente;
            switch (this.payLoad.empresa.id) {
              case 12: {
                this.strDependenteSocio = "BENEFICIÁRIO TITULAR";
                break;
              }
              default: {
                this.strDependenteSocio = "SÓCIO TITULAR";
                break;
              }
            }
          } else if (this.socioDependente.tipo == 'D') {
            this.strDependenteSocio = "DEPENDENTE DE: " + this.socioDependente.socioTitular;
            this.idSocio = this.socioDependente.idSocio;
          } else {
            this.strDependenteSocio = "CORTESIA DE: " + this.socioDependente.socioTitular;
            this.idSocio = this.socioDependente.idSocio;
          }
          this.aguardeDialog = false;
          if (this.socioDependente.telefone == null) {
            this.ultimoTelefoneAtendimento(idSocioDependente);
          } else {
            this.strTelefone = this.socioDependente.telefone;
          }
        }, (erro: any) => {
          this.erro.handle(erro);
          this.aguardeDialog = false;
        }
      );
    } else {
      this.renovarLoginDialog = true;
    }
  }

  ultimoTelefoneAtendimento(id: number) {
    if (!this.auth.isAccessTokenInvalido()) {
      this.strTelefone = '';
      this.aguardeDialog = true;
      this.juridicoService.ultimoTelefoneAtendimento(id, this.token).subscribe(
        (dados: any) => {
          if (dados) {
            this.strTelefone = dados.telefone;
          }
          this.aguardeDialog = false;
        }, (erro: any) => {
          this.erro.handle(erro);
          this.aguardeDialog = false;
        });
    } else {
      this.renovarLoginDialog = true;
    }
  }

  pesquisarMovimentacaoPorIDProcesso(pagina = 0) {
    if (!this.auth.isAccessTokenInvalido()) {
      this.aguardeDialog = true;
      this.movimentoProcessoFilter.pagina = pagina;
      this.juridicoService.buscrarMovimentacaoesPorIDProcesso(this.movimentoProcessoFilter, this.tipoSocio, this.token).subscribe(
        (dados: any) => {
          this.movimentacoesProcesso = dados.content;
          this.totalRegistrosMovimentacoesProcesso = dados.totalElements;
          this.aguardeDialog = false;
        }, (erro: any) => {
          this.erro.handle(erro);
          this.aguardeDialog = false;
        });
    } else {
      this.renovarLoginDialog = true;
    }
  }

  mudarPaginaMovimentacoesProcesso(event: any) {
    if (!this.auth.isAccessTokenInvalido()) {
      const pagina = event.first / event.rows
      this.pesquisarMovimentacaoPorIDProcesso(pagina);
    } else {
      this.renovarLoginDialog = true;
    }
  }

  grupoProcessoListar() {
    if (!this.auth.isAccessTokenInvalido()) {
      this.aguardeDialog = true;
      this.juridicoService.grupoProcessoListar(this.token).subscribe(
        (dados: any) => {
          this.gruposProcessos = dados.map((g: { descricao: any; id: any; }) => ({ label: g.descricao, value: g.id }));
          this.aguardeDialog = false;
        }, (erro: any) => {
          this.erro.handle(erro);
          this.aguardeDialog = false;
        }
      );
    } else {
      this.renovarLoginDialog = true;
    }
  }

  pesquisarAreaAtuacaoProcesso() {
    if (!this.auth.isAccessTokenInvalido()) {
      this.aguardeDialog = true;
      this.juridicoService.pesquisarAreaAtuacaoProcesso(this.token).subscribe(
        (dados: any) => {
          this.areasAtuacoes = dados.map((a: { descricao: any; id: any; }) => ({ label: a.descricao, value: a.id }));
          this.aguardeDialog = false;
        }, erro => {
          this.erro.handle(erro);
          this.aguardeDialog = false;
        });
    } else {
      this.renovarLoginDialog = true;
    }
  }

  fasesProcessoListar() {
    if (!this.auth.isAccessTokenInvalido()) {
      this.aguardeDialog = true;
      this.juridicoService.fasesProcessosListar(this.token).subscribe(
        (dados: any) => {
          this.fasesProcessos = dados.map((f: { descricao: any; id: any; }) => ({ label: f.descricao, value: f.id }));
          this.aguardeDialog = false;
        }, (erro: any) => {
          this.erro.handle(erro);
          this.aguardeDialog = false;
        }
      );
    } else {
      this.renovarLoginDialog = true;
    }
  }

  tribunaisListar() {
    if (!this.auth.isAccessTokenInvalido()) {
      this.aguardeDialog = true;
      this.juridicoService.tribunaisListar(this.token).subscribe(
        (dados: any) => {
          this.tribunais = dados.map((f: { descricao: any; id: any; }) => ({ label: f.descricao, value: f.id }));
          this.aguardeDialog = false;
        }, (erro: any) => {
          this.erro.handle(erro);
          this.aguardeDialog = false;
        }
      );
    } else {
      this.renovarLoginDialog = true;
    }
  }

  orgaosJulgadoresListar() {
    if (!this.auth.isAccessTokenInvalido()) {
      this.aguardeDialog = true;
      this.juridicoService.orgaosJulgadoresListar(this.token).subscribe(
        (dados: any) => {
          this.orgaoJulgadores = dados.map((f: { descricao: any; id: any; }) => ({ label: f.descricao, value: f.id }));
          this.aguardeDialog = false;
        }, (erro: any) => {
          this.erro.handle(erro);
          this.aguardeDialog = false;
        }
      );
    } else {
      this.renovarLoginDialog = true;
    }
  }

  instanciasListar() {
    if (!this.auth.isAccessTokenInvalido()) {
      this.aguardeDialog = true;
      this.juridicoService.instanciasListar(this.token).subscribe(
        (dados: any) => {
          this.instancias = dados.map((i: { descricao: any; id: any; }) => ({ label: i.descricao, value: i.id }));
          this.aguardeDialog = false;
        }, (erro: any) => {
          this.erro.handle(erro);
          this.aguardeDialog = false;
        }
      );
    } else {
      this.renovarLoginDialog = true;
    }
  }

  rotaNavegacaoProcessos() {
    if (!this.auth.isAccessTokenInvalido()) {
      this.rotaNavegar.navigate(['/juridico', this.idSocioDependente]);
    } else {
      this.renovarLoginDialog = true;
    }
  }

  login(usuario: string, senha: string) {
    this.aguardeDialog = true;
    this.auth.renovarLogin(usuario, senha).subscribe(
      (dados: any) => {
        this.token = dados.access_token;
        this.auth.armazenarToken(dados.access_token);
        this.payLoad = this.jwtDecoder.decodeToken(this.token);

        this.popularCampos();

        this.aguardeDialog = false;
        this.renovarLoginDialog = false;
      }, erro => {
        if (erro.status === 400) {
          if (erro.error.error === 'invalid_grant') {
            this.aguardeDialog = false;
            this.toasty.error('USUÁRIO OU SENHA INVÁLIDO!', 'ATENÇÃO!');
            this.rotaNavegar.navigate(['']);
          }
        }
        this.aguardeDialog = false;
        this.erro.handle(erro);
        this.rotaNavegar.navigate(['']);
      });
  }

}

